import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

import { DevicePlatformEnum } from './filterMappings.js';

export const PlatformEntityItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  extra: z
    .object({
      appsflyerDevicePlatform: DevicePlatformEnum.nullish(),
      adformIsRtb: z.boolean().nullish(),
      adformUuid: z.string().nullish(),
    })
    .nullish(),
});

export const PlatformEntitiesResponseSchema = createResponseSchema(
  PlatformEntityItemSchema,
);

export type PlatformEntityItemType = z.infer<typeof PlatformEntityItemSchema>;
export type PlatformEntitiesResponseType = z.infer<
  typeof PlatformEntitiesResponseSchema
>;

export type DevicePlatform = z.infer<typeof DevicePlatformEnum>;
